import React from 'react';
import { PropTypes } from 'prop-types';
import { FormLabel } from '@mui/material';

const CustomFormLabel = props => {
    const { children, labelClass, id, sx, ...rest } = props;

    return (
        <FormLabel
            id={id}
            className={labelClass}
            sx={theme => ({
                display: 'block',
                marginBottom: theme.spacing(),
                letterSpacing: 1.6,
                fontSize: 16,
                color: theme.palette.grey[600],
                '&:focused': {
                    color: 'inherit',
                    marginBottom: theme.spacing(),
                },
                ...(typeof sx === 'function' ? sx(theme) : sx),
            })}
            {...rest}
        >
            {children}
        </FormLabel>
    );
};

CustomFormLabel.propTypes = {
    ...FormLabel.propTypes,
    children: PropTypes.node.isRequired,
    id: PropTypes.string,
    labelClass: PropTypes.string,
};

export default CustomFormLabel;
